export function insertEach<T, K>(arr: T[], insertItem: K): (T | K)[] {
  return [...arr.slice(0, 1), ...arr.slice(1).reduce((arr: (T | K)[], item) => [...arr, insertItem, item], [])];
}
